import React from 'react';

import { useParams } from 'react-router-dom';

import Styled from './Header.styles';

import { OnboardingParams } from '../../types';

import { SleepioHeader } from './SleepioHeader';

import { LanguageSelector } from '../LanguageSelector/LanguageSelector';

import SparkDirectLogo from '@/assets/SparkDirectLogo.svg';

export const Header: React.FC = () => {
  const { product } = useParams<OnboardingParams>();

  if (product === 'sleepio' || product === 'sleepiorx') {
    return <SleepioHeader />;
  }

  return (
    <Styled.HeaderContainer>
      <Styled.Header>
        <div
          style={{
            display: 'flex',
            width: '100%',
            justifyContent: 'center',
            padding: '0px 0',
            position: 'relative',
          }}
        >
          <Styled.SparkLogo src={SparkDirectLogo} alt="Spark Direct Logo" style={{ marginRight: 56 }} />
          <LanguageSelector iconOnly />
        </div>
      </Styled.Header>
    </Styled.HeaderContainer>
  );
};
